module.exports = __webpack_public_path__ + "img/case8.056e1ad4.png";